export default [{
  path: 'datareport/:leftid/:parent_id',
  name: 'backend_datareport',
  component: () => import('@/views/backend/admin/mainpage/report/data'),
  meta: {
    tpflag: 'backend',
    title: '数据报表',
  }
}, {
  path: 'merchantreport/:leftid/:parent_id',
  name: 'backend_merchantreport',
  component: () => import('@/views/backend/admin/mainpage/report/merchant'),
  meta: {
    tpflag: 'backend',
    title: '商家报表',
  }
}, {
  path: 'channelreport/:leftid/:parent_id',
  name: 'backend_channelreport',
  component: () => import('@/views/backend/admin/mainpage/report/channel'),
  meta: {
    tpflag: 'backend',
    title: '渠道报表',
  }
}, {
  path: 'performancereport/:leftid/:parent_id',
  name: 'backend_performancereport',
  component: () => import('@/views/backend/admin/mainpage/report/performance'),
  meta: {
    tpflag: 'backend',
    title: '业绩报表',
  }
}]



// WEBPACK FOOTER //
// ./src/router/kdsuper/_report.js